// text types
export const DESCRIPTION = "description";
export const SUB_HEADER = "sub-header";
export const SOURCE = "source";
export const SOURCE_HEADER = "source-header";